<template>
  <div class="p-4">
    <div class="loader-overlay" v-if="isDataFetch">
      <b-spinner
        style="width: 3rem; height: 3rem"
        type="grow"
        class="text-white"
      ></b-spinner>
    </div>

    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-6 text-left">
            <h4>Dealer list</h4>
          </div>
          <div class="col-6 text-right">
            <appModalDealerNew></appModalDealerNew>
          </div>
        </div>
      </div>

      <div class="card-body">
        <div class="search-row mb-3">
          <div class="form-group search-box item mb-0">
            <label for="paginate" class="mb-0">Search</label>
            <input
              v-model="q"
              type="search"
              class="form-control"
              placeholder="Search ..."
              @keyup.enter="fnSearch()"
            />
          </div>

          <div class="status-box item">
            <div>
              <label for="paginate" class="mb-0">Status</label>
              <select
                v-model="selectedStatus"
                class="form-control sits_select"
                @change="fnSearch()"
              >
                <option value="">All Status</option>
                <option value="false">In-active</option>
                <option value="true">Active</option>
              </select>
            </div>
          </div>
          <div class="item">
            <button class="btn btn-sm btn-primary mt-4" @click="fnSearch()">
              Search
            </button>
          </div>
          <div class="item">
            <button class="btn btn-sm btn-primary mt-4" @click="fnClear()">
              Clear
            </button>
          </div>
        </div>
        <div class="table-responsive table-sm tableDealerList">
          <table
            class="
              v-datatable-light
              table table-bordered table-hover table-striped table-center
            "
          >
            <thead>
              <tr>
                <th class="header-item header-column-0"></th>
                <th class="header-item header-column-1">
                  <a href="#" @click.prevent="fnChangeSort('id')">Id</a>
                  <span v-if="sort_direction == 'desc' && sort_field == 'id'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'id'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item header-column-2">
                  <a href="#" @click.prevent="fnChangeSort('name')"
                    >Dealer name</a
                  >
                  <span v-if="sort_direction == 'desc' && sort_field == 'name'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'name'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item header-column-3">Address</th>
                <th class="header-item header-column-4">Contact Name</th>
                <th class="header-item header-column-5">Contact Email</th>
                <th class="header-item header-column-6">Contact Phone</th>
                <th class="header-item header-column-6">Commission</th>
                <th class="header-item header-column-7">
                  <a href="#" @click.prevent="fnChangeSort('created_at')"
                    >Created</a
                  >
                  <span
                    v-if="
                      sort_direction == 'desc' && sort_field == 'created_at'
                    "
                    >&uarr;</span
                  >
                  <span
                    v-if="sort_direction == 'asc' && sort_field == 'created_at'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item header-column-8">
                  <a href="#" @click.prevent="fnChangeSort('status')">Status</a>
                  <span
                    v-if="sort_direction == 'desc' && sort_field == 'status'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'status'"
                    >&darr;</span
                  >
                </th>

                <th class="header-item header-column-9">Actions</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(row, index) in getDealerPaginateData.data">
                <tr :key="(row, index)">
                  <td
                    class="column-0"
                    @click="toggle(index)"
                    :class="{ opened: opened.includes(index) }"
                  >
                    <span class="text-info pl-2"
                      ><i class="fas fa-outdent"></i
                    ></span>
                  </td>
                  <td class="column-1">{{ row.id }}</td>
                  <td class="column-2">{{ row.name }}</td>
                  <td class="column-3">
                    {{ row.street }} {{ row.suburb }} {{ row.state }}
                    {{ row.postCode }}
                  </td>
                  <td class="column-4">
                    {{ row.accountFullName }}
                  </td>
                  <td class="column-5">
                    {{ row.accountEmail }}
                  </td>
                  <td class="column-5">
                    {{ row.accountPhone }}
                  </td>
                  <td class="column-5 column-r">
                    {{ row.dealerBrokerage }}
                  </td>
                  <td class="column-6">
                    <span v-if="row.created_at != null">{{
                      row.created_at | dateConvertDDMMYYYY
                    }}</span>
                    <span v-else></span>
                  </td>
                  <td class="column-7">
                    <div v-if="row.status == 1">
                      <span class="badge bdg-active">Active</span>
                    </div>
                    <div v-if="row.status == 0">
                      <span class="badge bdg-in-active">In-active</span>
                    </div>
                  </td>
                  <td class="column-8">
                    <div class="d-flex">
                      <appModalDealerEdit :propsData="row"></appModalDealerEdit>
                    </div>
                  </td>
                </tr>
                <!-- Expandable section -->
                <tr v-if="opened.includes(index)">
                  <appDealerList :colspan="14" :row="row" />
                </tr>
              </template>

              <!-- Pagination -->
              <tr>
                <td colspan="11">
                  <div class="sits-pagination-row">
                    <div class="items-per-page">
                      <div class="pr-2">
                        <p class="mb-0">Items per page</p>
                      </div>
                      <div class="pr-5">
                        <select
                          v-model="recordsPerPage"
                          class="form-control sits_select"
                          @change="fnRecordsPerPage()"
                        >
                          <option value="10">10</option>
                          <option value="15">15</option>
                          <option value="20">20</option>
                          <option value="30">30</option>
                          <option value="40">40</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>

                    <div>
                      <pagination
                        :limit="5"
                        :data="getDealerPaginateData"
                        @pagination-change-page="fnGetDealerList"
                      ></pagination>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import pagination from 'laravel-vue-pagination'
import appModalDealerNew from '../../../components/admin/dealer/ModalDealerNew.vue'
import appModalDealerEdit from '../../../components/admin/dealer/ModalDealerEdit.vue'
import appDealerList from '../../../components/admin/dealer/DealerListExpand.vue'

export default {
  name: 'adminLeadsList',
  components: {
    pagination,
    appModalDealerNew,
    appModalDealerEdit,
    appDealerList
  },
  data() {
    return {
      isDataFetch: true,
      opened: [],
      quoteList: {},
      recordsPerPage: 15,
      page: 1,
      q: '',
      selectedStatus: '',
      sort_direction: 'desc',
      sort_field: 'id',
      quoteCalculation: {},
      paginate: {
        dealerUserId: '',
        page: 1,
        recordsPerPage: 15,
        q: '',
        selectedStatus: '',
        sort_direction: 'desc',
        sort_field: 'id'
      },
      referralPartnerId: ''
    }
  },
  computed: {
    ...mapGetters(['getDealerPaginateData', 'getDealerPaginate'])
  },
  methods: {
    ...mapActions(['fetchDealerPaginate']),

    toggle(id) {
      const index = this.opened.indexOf(id)
      if (index > -1) {
        this.opened.splice(index, 1)
      } else {
        this.opened.push(id)
      }
    },

    fnGetDealerList: async function (page = 1) {
      let obj1 = this.paginate
      let obj2 = {
        page: page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchDealerPaginate(objNew)
    },

    fnRecordsPerPage() {
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }

      this.fetchDealerPaginate(objNew)
    },

    fnSearch() {
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchDealerPaginate(objNew)
    },

    fnChangeSort(field) {
      if (this.sort_field == field) {
        this.sort_direction = this.sort_direction == 'asc' ? 'desc' : 'asc'
      } else {
        this.sort_field = field
      }
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchDealerPaginate(objNew)
    },

    fnClear() {
      this.q = ''
      this.selectedStatus = ''
      this.fromDate = ''
      this.toDate = ''
      let obj1 = this.paginate
      let obj2 = {
        page: 1,
        recordsPerPage: 15,
        q: '',
        selectedStatus: '',
        sort_direction: 'desc',
        sort_field: 'id'
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchDealerPaginate(objNew)
    }
  },
  async mounted() {
    this.isDataFetch = true
    let obj1 = this.paginate
    let obj2 = {
      page: 1,
      recordsPerPage: 15,
      q: '',
      selectedStatus: '',
      sort_direction: 'desc',
      sort_field: 'id'
    }
    let objNew = { ...obj1, ...obj2 }
    await this.fetchDealerPaginate(objNew)
    this.isDataFetch = false
  }
}
</script>

<style lang="scss" scoped>
.search-row {
  display: flex;
  // justify-content: space-between;
  gap: 20px;
  .search-box {
    width: 350px;
  }
  .ref-partner-box {
    width: 250px;
  }
  .status-box {
    width: 150px;
  }
  .date-box {
    width: 130px;
  }

  .item {
    align-self: center;
  }
}

.sits-pagination-row {
  display: flex;
  gap: 10px;
  align-items: baseline;
  padding-top: 5px;
  padding-bottom: 5px;

  .items-per-page {
    display: flex;
    align-items: baseline;
  }

  ul.pagination {
    margin-bottom: 0;
  }

  .page-item.active .page-link {
    z-index: 3;
    color: #fff;
    background-color: red;
    border-color: red;
  }
}

.is-leads-nots-exist {
  color: var(--iq-color10) !important;
}
.no-leads-nots-exist {
  color: var(--iq-info) !important;
}
</style>
